"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.confirmAccountNumber = exports.bankRoutingNumber = void 0;

var Yup = _interopRequireWildcard(require("yup"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MIN_ACCOUNT_LENGTH = 6;
var MAX_ACCOUNT_LENGTH = 17;
var ROUTING_LENGTH = 9;

var bankAccountType = function bankAccountType() {
  var required = "Account type required";
  return Yup.string().required(required);
};

var bankAccountNumber = function bankAccountNumber() {
  var required = "Account number required";
  var min = "Account number must be minimum ".concat(MIN_ACCOUNT_LENGTH, " characters");
  var max = "Account number must be maximum ".concat(MAX_ACCOUNT_LENGTH, " characters");
  return Yup.string().required(required).min(MIN_ACCOUNT_LENGTH, min).max(MAX_ACCOUNT_LENGTH, max);
};

var confirmAccountNumber = function confirmAccountNumber() {
  var accountNumberValidator = bankAccountNumber();
  var match = "Account number must match";
  var sibling = 'bankAccountNumber';
  return accountNumberValidator.oneOf([Yup.ref(sibling), null], match);
};

exports.confirmAccountNumber = confirmAccountNumber;

var bankRoutingNumber = function bankRoutingNumber() {
  var required = "Routing number required";
  var length = "Routing number must be ".concat(ROUTING_LENGTH, " characters");
  return Yup.string().required(required).min(ROUTING_LENGTH, length).max(ROUTING_LENGTH, length);
};

exports.bankRoutingNumber = bankRoutingNumber;

var createValidationSchema = function createValidationSchema() {
  return Yup.object().shape({
    bankAccountType: bankAccountType(),
    bankRoutingNumber: bankRoutingNumber(),
    bankAccountNumber: bankAccountNumber(),
    confirmAccountNumber: confirmAccountNumber()
  });
};

var _default = createValidationSchema;
exports["default"] = _default;